export default "__VITE_ASSET__DsStku_p__"